<template>
  <div class="gpl">

    <!-- ════════════════════ HEADER CARD ════════════════════ -->
    <div class="gpl-dash-header">
      <div class="gpl-dash-header-top">
        <div>
          <div class="gpl-eyebrow">MARKETING · EMAIL TEMPLATES</div>
          <h1 class="gpl-title">Plantillas de email</h1>
        </div>
        <div class="gpl-header-actions">
          <div class="gpl-stat-pill">
            <i class="fa-regular fa-folder"></i>
            <strong>{{ plantillas.length }}</strong>
            <span>guardadas</span>
          </div>
          <button class="gpl-btn gpl-btn--ghost" v-if="plantillaSelect.id" @click="enviarEmail">
            <i class="fa-solid fa-paper-plane"></i>
            <span>Test envío</span>
          </button>
          <button class="gpl-btn gpl-btn--primary" v-if="plantillaSelect.id" @click="savePlantilla">
            <i class="fa-solid fa-floppy-disk"></i>
            <span>Guardar plantilla</span>
          </button>
        </div>
      </div>
    </div>

    <!-- ════════════════════ BODY ════════════════════ -->
    <div class="gpl-body">

      <!-- SIDEBAR -->
      <aside class="gpl-sidebar">
        <div class="gpl-side-card">
          <div class="gpl-side-head">
            <h3 class="gpl-side-title">Listado</h3>
            <span class="gpl-side-count">{{ plantillasFiltradas.length }}</span>
          </div>

          <div class="gpl-side-search">
            <i class="fa-solid fa-magnifying-glass gpl-side-search-icon"></i>
            <input
              v-model="filtro"
              type="text"
              placeholder="Buscar plantilla..."
            />
            <button v-if="filtro" class="gpl-side-search-clear" @click="filtro = ''">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div class="gpl-side-create">
            <input
              type="text"
              v-model="texto"
              placeholder="Nombre de la nueva plantilla..."
              @keyup.enter="addPlantilla"
            />
            <button class="gpl-btn gpl-btn--primary gpl-btn--sm" @click="addPlantilla" :disabled="!texto.trim()">
              <i class="fa-solid fa-plus"></i>
            </button>
          </div>

          <div class="gpl-side-list">
            <button
              v-for="plantilla in plantillasFiltradas"
              :key="plantilla.id"
              class="gpl-item"
              :class="{ 'is-active': plantillaSelect.id === plantilla.id }"
              @click="selectPlantilla(plantilla)"
            >
              <span class="gpl-item-init" :class="'gpl-item-init--' + initialsTone(plantilla.nombre)">
                {{ initials(plantilla.nombre) }}
              </span>
              <span class="gpl-item-body">
                <span class="gpl-item-name">{{ plantilla.nombre }}</span>
                <span class="gpl-item-meta">
                  <i class="fa-regular fa-envelope"></i>
                  <span>{{ plantilla.asunto || 'Sin asunto' }}</span>
                </span>
              </span>
              <span class="gpl-item-del" @click.stop="confirmDelete(plantilla)" title="Eliminar">
                <i class="fa-solid fa-trash"></i>
              </span>
            </button>

            <div v-if="plantillasFiltradas.length === 0" class="gpl-side-empty">
              <i class="fa-regular fa-folder-open"></i>
              <p>{{ filtro ? 'Sin resultados' : 'Sin plantillas todavía' }}</p>
            </div>
          </div>
        </div>
      </aside>

      <!-- EDITOR -->
      <main class="gpl-editor">

        <!-- EMPTY STATE -->
        <div v-if="!plantillaSelect.id" class="gpl-editor-empty">
          <div class="gpl-editor-empty-icon">
            <i class="fa-regular fa-pen-to-square"></i>
          </div>
          <h2>Selecciona una plantilla</h2>
          <p>Elige una plantilla del listado para empezar a editarla, o crea una nueva desde la barra lateral.</p>
        </div>

        <!-- CONTENT -->
        <div v-else class="gpl-editor-card">
          <div class="gpl-editor-head">
            <div class="gpl-editor-eyebrow">PLANTILLA</div>
            <h2 class="gpl-editor-name">{{ plantillaSelect.nombre }}</h2>
            <div class="gpl-editor-status">
              <span class="gpl-status-dot"></span>
              <span>Editando · cambios sin guardar se perderán al salir</span>
            </div>
          </div>

          <div class="gpl-editor-subject">
            <label>Asunto del email</label>
            <input
              type="text"
              v-model="plantillaSelect.asunto"
              placeholder="Escribe el asunto que verá el destinatario..."
            />
          </div>

          <div class="gpl-editor-body">
            <quill-editor
              v-model="plantillaSelect.contenido"
              ref="quillEditor"
              :options="editorOption"
            />
          </div>

          <div class="gpl-editor-foot">
            <div class="gpl-editor-foot-info">
              <i class="fa-regular fa-circle-question"></i>
              <span>Las imágenes se ajustan automáticamente a {{ maxWidthImg }} de ancho.</span>
            </div>
            <button class="gpl-btn gpl-btn--primary" @click="savePlantilla">
              <i class="fa-solid fa-floppy-disk"></i>
              <span>Guardar plantilla</span>
            </button>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { quillEditor } from 'vue-quill-editor'
import axios from '@axios'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
    components: {
            BCardCode,
            quillEditor
        },
    data() {
        return {
            editorOption2: {
            theme: 'snow',
            syntax: false,
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'font': [] }],
                    [{ 'size': ['small', 'medium', 'large', 'huge'] }],
                    [{ 'align': [] }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    ['ordered', 'bullet'],
                    [{ 'list': 'check' }],
                    ['blockquote'],
                    ['link', 'image'],
                    ['link'],
                    ['image', 'video'],
                    ['code-block'],
                    [{ 'script': 'sub' }, { 'script': 'super' }],
                    ['emoji'],
                    ['clean'],
                    ['table'],
                    ['paste']
                    ],
            },
          },
          editorOption: {
            theme: 'snow',
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            ['link', 'imageUrl', 'video', 'formula'],

                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
                            [{ 'script': 'sub'}, { 'script': 'super' }],
                            [{ 'indent': '-1'}, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],

                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': [] }],
                            [{ 'align': [] }],

                            ['clean'],
                        ],
                        imageResize: true,
                        handlers: {
                            'imageUrl': function() {
                                const url = prompt('Introduce la URL de la imagen');

                                if (url) {
                                const range = this.quill.getSelection();
                                this.quill.insertEmbed(range.index, 'image', url);
                                const imageElement = this.quill.root.querySelector(`img[src="${url}"]`);
                                if (imageElement) {
                                    imageElement.style.maxWidth = "500px";
                                }
                                }
                            }
                        }
                    },
             }
            },

            texto: '',
            filtro: '',
            content: ``,
            plantillaSelect: {
                id: 0,
                nombre: '',
                contenido: '',
                asunto: ''
            },
            plantillas:[],
            maxWidthImg: "500px",
        }
    },
    computed: {
        plantillasFiltradas() {
            if (!this.filtro) return this.plantillas;
            const term = this.filtro.toLowerCase();
            return this.plantillas.filter(p =>
                (p.nombre && p.nombre.toLowerCase().includes(term)) ||
                (p.asunto && p.asunto.toLowerCase().includes(term))
            );
        }
    },
    methods: {
        initials(name) {
            if (!name) return '·';
            const parts = String(name).trim().split(/\s+/);
            if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
            return (parts[0][0] + parts[1][0]).toUpperCase();
        },
        initialsTone(name) {
            if (!name) return 'ink';
            const tones = ['indigo', 'emerald', 'amber', 'sky', 'coral', 'ink'];
            let hash = 0;
            for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
            return tones[hash % tones.length];
        },
        confirmDelete(plantilla) {
            if (window.confirm('¿Eliminar la plantilla "' + plantilla.nombre + '"?')) {
                this.deletePlantilla(plantilla.id);
            }
        },
        addIconToVideoButton() {
            // Acceder al contenedor del toolbar de Quill y agregar el ícono
            if (!this.$refs.quillEditor) return;
            const toolbar = this.$refs.quillEditor.$el.querySelector('.ql-toolbar');
            if (!toolbar) return;
            const video2Button = toolbar.querySelector('.ql-imageUrl');

            if (video2Button) {
                const icon = document.createElement('i');
                icon.className = 'fa-solid fa-image';
                video2Button.innerHTML = '';
                video2Button.appendChild(icon);
            }
        },
        async loadItems(){
            axios.post("/uso", {seccion:"gestion-plantillas"});

            const responsePlantillas = await axios.get("/seo/plantillas");
            this.plantillas = responsePlantillas.data;
        },
        selectPlantilla(plantilla) {
            this.plantillaSelect = plantilla;
            this.content = plantilla.contenido;

            setTimeout(() => {
                if (!this.$refs.quillEditor) return;
                const images = this.$refs.quillEditor.$el.querySelectorAll('img');
                images.forEach(img => {
                    img.style.maxWidth = this.maxWidthImg;
                });
                this.addIconToVideoButton();
            }, 10);
        },
        addPlantilla() {
            if (!this.texto.trim()) return;
            const nuevaPlantilla = {
                id: 0,
                nombre: this.texto,
                contenido: '',
                asunto: ''
            };

            axios
                .post("/seo/plantillas", nuevaPlantilla)
                .then(response => response.data)
                .then(res => {
                    nuevaPlantilla.id = res.insertId;
                    this.plantillas.push(nuevaPlantilla);
                    this.texto = '';
                    this.selectPlantilla(nuevaPlantilla);
                });
        },
        deletePlantilla(id) {
            axios
            .delete("/seo/plantillas/"+id)
            .then(response => response.data)
            .then(res => {
                this.plantillas = this.plantillas.filter(plantilla => plantilla.id !== id);

                if(this.plantillaSelect.id == id){
                    this.plantillaSelect = {
                        id: 0,
                        nombre: '',
                        contenido: '',
                        asunto: ''
                    };
                }
            });
        },
        savePlantilla() {

            let contenidoConEstilos = this.plantillaSelect.contenido;

            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = contenidoConEstilos;

            let images = tempDiv.querySelectorAll('img');
            images.forEach(img => {
                img.style.maxWidth = this.maxWidthImg;
            });

            contenidoConEstilos = tempDiv.innerHTML;

            let info = {
                id: this.plantillaSelect.id,
                contenido: contenidoConEstilos,
                asunto: this.plantillaSelect.asunto,
            }

            axios
                .put("/seo/plantillas", info)
                .then(response => response.data)
                .then(res => {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: "Plantilla guardada correctamente",
                            icon: "EditIcon",
                            variant: "success",
                        },
                    });
                }).catch(err => {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: "Error al guardar la plantilla",
                            icon: "EditIcon",
                            variant: "danger",
                        },
                    });
                });
        },
        enviarEmail(){

            let contenidoConEstilos = this.plantillaSelect.contenido;

            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = contenidoConEstilos;

            let images = tempDiv.querySelectorAll('img');
            images.forEach(img => {
                img.style.maxWidth = this.maxWidthImg;
            });

            contenidoConEstilos = tempDiv.innerHTML;

            this.plantillaSelect.contenido = contenidoConEstilos;

            axios
                .post("/seo/plantillas/enviarEmail", this.plantillaSelect)
                .then(response => response.data)
                .then(res => {
                    console.log(res);
                });
        }
    },
    mounted() {
        this.loadItems();
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

// ══════════════════════════════════════════════════════════════
// DATA-DENSE DASHBOARD — GESTIÓN DE PLANTILLAS
// Same tokens as /pedido-taller-vero/fabricando
// ══════════════════════════════════════════════════════════════

$gpl-bg:        #F8FAFC;
$gpl-surface:   #FFFFFF;
$gpl-surface-2: #F1F5F9;
$gpl-border:    #E2E8F0;
$gpl-divider:   #EEF2F7;

$gpl-ink:       #1E293B;
$gpl-text:      #1E293B;
$gpl-mute:      #64748B;
$gpl-soft:      #94A3B8;

$gpl-primary:    #3B82F6;
$gpl-primary-soft: #60A5FA;
$gpl-primary-bg: rgba(59, 130, 246, 0.10);
$gpl-cta:        #F97316;
$gpl-cta-bg:     rgba(249, 115, 22, 0.12);

$gpl-emerald:    #10B981;
$gpl-emerald-bg: rgba(16, 185, 129, 0.12);
$gpl-coral:      #EF4444;
$gpl-coral-bg:   rgba(239, 68, 68, 0.12);
$gpl-amber:      #F59E0B;
$gpl-amber-bg:   rgba(245, 158, 11, 0.12);
$gpl-indigo:     #3B82F6;
$gpl-indigo-bg:  rgba(59, 130, 246, 0.10);
$gpl-sky:        #06B6D4;
$gpl-sky-bg:     rgba(6, 182, 212, 0.12);

$gpl-r:    12px;
$gpl-r-sm: 8px;
$gpl-shadow: 0 1px 0 rgba(15, 23, 42, 0.04), 0 2px 6px rgba(15, 23, 42, 0.04);

.gpl {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  background: $gpl-bg;
  color: $gpl-text;
  margin: -2rem;
  padding: 28px 32px 56px;
  min-height: calc(100vh - 4rem);
  font-feature-settings: "tnum", "zero";

  *, *::before, *::after { box-sizing: border-box; }

  // ──────────── HEADER CARD (matches Fabricando) ────────────
  .gpl-dash-header {
    background: $gpl-surface;
    border: 1px solid $gpl-border;
    border-radius: 14px;
    padding: 18px 20px 16px;
    margin-bottom: 18px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  }

  .gpl-dash-header-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    flex-wrap: wrap;
  }

  .gpl-eyebrow {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    color: $gpl-primary;
    letter-spacing: 0.14em;
    margin-bottom: 4px;

    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      background: $gpl-cta;
      border-radius: 50%;
      margin-right: 6px;
      vertical-align: middle;
      animation: gpl-pulse 2s infinite;
    }
  }

  .gpl-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 22px;
    font-weight: 700;
    color: $gpl-ink;
    line-height: 1.1;
    letter-spacing: -0.01em;
    margin: 0;
  }

  .gpl-header-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }

  .gpl-stat-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 38px;
    padding: 0 14px;
    background: $gpl-bg;
    border: 1px solid $gpl-border;
    border-radius: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: $gpl-mute;

    i { color: $gpl-primary; font-size: 11px; }
    strong {
      font-family: 'JetBrains Mono', monospace;
      font-size: 13px;
      font-weight: 700;
      color: $gpl-ink;
      font-feature-settings: "tnum";
    }
  }

  // ──────────── BUTTONS ────────────
  .gpl-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 38px;
    padding: 0 16px;
    background: $gpl-surface;
    border: 1px solid $gpl-border;
    border-radius: $gpl-r-sm;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: $gpl-text;
    cursor: pointer;
    transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
    white-space: nowrap;

    i { font-size: 12px; }

    &:hover {
      background: $gpl-surface-2;
      border-color: $gpl-soft;
    }

    &:disabled { opacity: 0.5; cursor: not-allowed; }

    &--primary {
      background: $gpl-ink;
      border-color: $gpl-ink;
      color: #fff;

      &:hover:not(:disabled) {
        background: lighten($gpl-ink, 8%);
        border-color: lighten($gpl-ink, 8%);
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.2);
      }
    }

    &--ghost { background: $gpl-surface; }

    &--sm {
      height: 38px;
      width: 38px;
      padding: 0;
      flex-shrink: 0;

      i { font-size: 13px; }
      span { display: none; }
    }
  }

  // ──────────── BODY (sidebar + editor) ────────────
  .gpl-body {
    display: grid;
    grid-template-columns: 320px 1fr;
    gap: 18px;
    align-items: start;

    @media (max-width: 1000px) {
      grid-template-columns: 1fr;
    }
  }

  // ──────────── SIDEBAR ────────────
  .gpl-side-card {
    background: $gpl-surface;
    border: 1px solid $gpl-border;
    border-radius: $gpl-r;
    box-shadow: $gpl-shadow;
    overflow: hidden;
    position: sticky;
    top: 24px;
    max-height: calc(100vh - 80px);
    display: flex;
    flex-direction: column;
  }

  .gpl-side-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 18px 12px;
    border-bottom: 1px solid $gpl-divider;
  }

  .gpl-side-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: $gpl-ink;
    margin: 0;
  }

  .gpl-side-count {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    font-weight: 700;
    color: $gpl-indigo;
    background: $gpl-indigo-bg;
    padding: 3px 8px;
    border-radius: 999px;
  }

  // Search
  .gpl-side-search {
    position: relative;
    padding: 12px 14px 0;
  }

  .gpl-side-search-icon {
    position: absolute;
    left: 24px;
    top: calc(50% + 6px);
    transform: translateY(-50%);
    color: $gpl-soft;
    font-size: 11px;
    pointer-events: none;
  }

  .gpl-side-search input {
    width: 100%;
    height: 34px;
    padding: 0 32px 0 30px;
    background: $gpl-surface-2;
    border: 1px solid $gpl-border;
    border-radius: $gpl-r-sm;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    color: $gpl-text;
    transition: all 150ms ease;

    &::placeholder { color: $gpl-soft; }

    &:focus {
      outline: none;
      border-color: $gpl-ink;
      background: $gpl-surface;
      box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.06);
    }
  }

  .gpl-side-search-clear {
    position: absolute;
    right: 22px;
    top: calc(50% + 6px);
    transform: translateY(-50%);
    width: 18px;
    height: 18px;
    border: 0;
    background: $gpl-divider;
    color: $gpl-mute;
    border-radius: 50%;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;

    &:hover { background: $gpl-coral; color: #fff; }
  }

  // Create
  .gpl-side-create {
    display: flex;
    gap: 6px;
    padding: 10px 14px 12px;

    input {
      flex: 1;
      height: 38px;
      padding: 0 12px;
      background: $gpl-surface;
      border: 1px solid $gpl-border;
      border-radius: $gpl-r-sm;
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 12px;
      color: $gpl-text;
      transition: all 150ms ease;

      &::placeholder { color: $gpl-soft; }
      &:focus {
        outline: none;
        border-color: $gpl-ink;
        box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.06);
      }
    }
  }

  // List
  .gpl-side-list {
    flex: 1;
    overflow-y: auto;
    padding: 4px 10px 14px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    // scrollbar
    &::-webkit-scrollbar { width: 6px; }
    &::-webkit-scrollbar-track { background: transparent; }
    &::-webkit-scrollbar-thumb { background: $gpl-border; border-radius: 3px; }
    &::-webkit-scrollbar-thumb:hover { background: $gpl-soft; }
  }

  .gpl-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 10px;
    background: transparent;
    border: 1px solid transparent;
    border-radius: $gpl-r-sm;
    cursor: pointer;
    transition: all 150ms ease;
    text-align: left;
    width: 100%;
    font-family: inherit;

    &:hover {
      background: $gpl-surface-2;

      .gpl-item-del { opacity: 1; }
    }

    &.is-active {
      background: $gpl-indigo-bg;
      border-color: rgba(79, 70, 229, 0.2);

      .gpl-item-name { color: $gpl-indigo; }
    }
  }

  .gpl-item-init {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: $gpl-r-sm;
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;

    &--indigo  { background: $gpl-indigo-bg;  color: $gpl-indigo; }
    &--emerald { background: $gpl-emerald-bg; color: $gpl-emerald; }
    &--coral   { background: $gpl-coral-bg;   color: $gpl-coral; }
    &--amber   { background: $gpl-amber-bg;   color: $gpl-amber; }
    &--sky     { background: $gpl-sky-bg;     color: $gpl-sky; }
    &--ink     { background: rgba(15,23,42,0.06); color: $gpl-ink; }
  }

  .gpl-item-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .gpl-item-name {
    font-size: 13px;
    font-weight: 600;
    color: $gpl-ink;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.3;
  }

  .gpl-item-meta {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
    color: $gpl-mute;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    i { font-size: 9px; }
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 180px;
    }
  }

  .gpl-item-del {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 6px;
    color: $gpl-soft;
    opacity: 0;
    transition: all 150ms ease;
    flex-shrink: 0;

    &:hover {
      background: $gpl-coral-bg;
      color: $gpl-coral;
    }
  }

  .gpl-side-empty {
    padding: 28px 16px;
    text-align: center;
    color: $gpl-soft;

    i { font-size: 22px; margin-bottom: 8px; display: block; }
    p { margin: 0; font-size: 12px; font-weight: 500; }
  }

  // ──────────── EDITOR ────────────
  .gpl-editor {
    min-width: 0;
  }

  .gpl-editor-empty {
    background: $gpl-surface;
    border: 1px dashed $gpl-border;
    border-radius: $gpl-r;
    padding: 80px 32px;
    text-align: center;
    color: $gpl-mute;

    .gpl-editor-empty-icon {
      width: 72px;
      height: 72px;
      margin: 0 auto 18px;
      background: $gpl-indigo-bg;
      color: $gpl-indigo;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
    }

    h2 {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 20px;
      font-weight: 700;
      color: $gpl-ink;
      margin: 0 0 8px;
      letter-spacing: -0.01em;
    }

    p {
      font-size: 13px;
      max-width: 420px;
      margin: 0 auto;
      line-height: 1.5;
    }
  }

  .gpl-editor-card {
    background: $gpl-surface;
    border: 1px solid $gpl-border;
    border-radius: $gpl-r;
    box-shadow: $gpl-shadow;
    overflow: hidden;
  }

  .gpl-editor-head {
    padding: 22px 26px 16px;
    border-bottom: 1px solid $gpl-divider;
  }

  .gpl-editor-eyebrow {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.14em;
    color: $gpl-indigo;
    margin-bottom: 4px;
  }

  .gpl-editor-name {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 22px;
    font-weight: 800;
    color: $gpl-ink;
    letter-spacing: -0.02em;
    margin: 0 0 8px;
    line-height: 1.15;
  }

  .gpl-editor-status {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 11px;
    font-weight: 500;
    color: $gpl-mute;

    .gpl-status-dot {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: $gpl-amber;
      animation: gpl-pulse 2s infinite;
    }
  }

  // Subject
  .gpl-editor-subject {
    padding: 18px 26px;
    border-bottom: 1px solid $gpl-divider;

    label {
      display: block;
      font-size: 11px;
      font-weight: 600;
      color: $gpl-mute;
      letter-spacing: 0.02em;
      margin-bottom: 6px;
    }

    input {
      width: 100%;
      height: 42px;
      padding: 0 14px;
      background: $gpl-surface-2;
      border: 1px solid $gpl-border;
      border-radius: $gpl-r-sm;
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 14px;
      font-weight: 500;
      color: $gpl-ink;
      transition: all 150ms ease;

      &::placeholder { color: $gpl-soft; font-weight: 400; }

      &:focus {
        outline: none;
        border-color: $gpl-ink;
        background: $gpl-surface;
        box-shadow: 0 0 0 3px rgba(15, 23, 42, 0.06);
      }
    }
  }

  // Quill body
  .gpl-editor-body {
    padding: 0 26px 18px;
    background: $gpl-surface;
  }

  .gpl-editor-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 14px 26px 18px;
    border-top: 1px solid $gpl-divider;
    background: $gpl-surface-2;
    flex-wrap: wrap;
  }

  .gpl-editor-foot-info {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 12px;
    color: $gpl-mute;

    i { font-size: 11px; color: $gpl-soft; }
  }

  // ──────────── QUILL OVERRIDES ────────────
  .ql-toolbar.ql-snow {
    border: 1px solid $gpl-border !important;
    border-radius: $gpl-r-sm $gpl-r-sm 0 0 !important;
    background: $gpl-surface-2;
    padding: 10px 12px;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }

  .ql-container.ql-snow {
    border: 1px solid $gpl-border !important;
    border-top: 0 !important;
    border-radius: 0 0 $gpl-r-sm $gpl-r-sm !important;
    background: $gpl-surface;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14px;
    color: $gpl-text;
    min-height: 320px;
  }

  .ql-editor {
    padding: 18px 20px;
    line-height: 1.6;
    font-size: 14px;
    color: $gpl-text;
    min-height: 320px;

    &.ql-blank::before {
      color: $gpl-soft;
      font-style: normal;
      font-size: 13px;
    }
  }

  .ql-snow .ql-stroke { stroke: $gpl-mute; }
  .ql-snow .ql-fill, .ql-snow .ql-stroke.ql-fill { fill: $gpl-mute; }
  .ql-snow .ql-picker { color: $gpl-mute; }

  .ql-snow.ql-toolbar button:hover,
  .ql-snow.ql-toolbar button.ql-active {
    .ql-stroke { stroke: $gpl-ink; }
    .ql-fill { fill: $gpl-ink; }
  }
  .ql-snow.ql-toolbar button.ql-active {
    background: rgba(15, 23, 42, 0.06);
    border-radius: 4px;
  }

  // ──────────── ANIMATIONS ────────────
  @keyframes gpl-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.4; transform: scale(0.7); }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      transition-duration: 0.01ms !important;
    }
  }
}

// ══════════ DARK MODE ══════════
.dark-layout .gpl {
  background: #161616;
  color: #d0d2d6;

  .gpl-title { color: #e4e6eb; }
  .gpl-subtitle { color: #8e9099; strong { color: #e4e6eb; } }
  .gpl-crumbs .gpl-crumb-current { color: #e4e6eb; }

  .gpl-side-card,
  .gpl-editor-card {
    background: #1f1f1f;
    border-color: #2c2c2c;
    box-shadow: none;
  }
  .gpl-editor-empty {
    background: #1f1f1f;
    border-color: #2c2c2c;
  }
  .gpl-side-head { border-bottom-color: #2c2c2c; }
  .gpl-side-title { color: #e4e6eb; }
  .gpl-editor-name { color: #e4e6eb; }
  .gpl-editor-head { border-bottom-color: #2c2c2c; }
  .gpl-editor-subject { border-bottom-color: #2c2c2c; }
  .gpl-editor-foot { background: #1a1a1a; border-top-color: #2c2c2c; }

  .gpl-side-search input,
  .gpl-side-create input,
  .gpl-editor-subject input {
    background: #1a1a1a;
    border-color: #2c2c2c;
    color: #d0d2d6;
    &:focus { background: #242424; border-color: #fff; }
  }

  .gpl-item:hover { background: #242424; }
  .gpl-item.is-active { background: rgba(79, 70, 229, 0.18); border-color: rgba(79, 70, 229, 0.4); }
  .gpl-item-name { color: #e4e6eb; }
  .gpl-item-meta { color: #8e9099; }

  .gpl-btn {
    background: #1f1f1f;
    border-color: #2c2c2c;
    color: #d0d2d6;
    &:hover:not(:disabled) { background: #2a2a2a; }
    &--primary {
      background: #fff;
      color: #0F172A;
      border-color: #fff;
      &:hover:not(:disabled) { background: #f0f0f0; border-color: #f0f0f0; }
    }
  }

  .ql-toolbar.ql-snow,
  .ql-container.ql-snow {
    background: #1a1a1a !important;
    border-color: #2c2c2c !important;
  }
  .ql-editor { color: #d0d2d6; }
  .ql-snow .ql-stroke { stroke: #8e9099; }
  .ql-snow .ql-fill { fill: #8e9099; }
  .ql-snow .ql-picker { color: #8e9099; }
  .ql-snow.ql-toolbar button:hover,
  .ql-snow.ql-toolbar button.ql-active {
    .ql-stroke { stroke: #e4e6eb; }
    .ql-fill { fill: #e4e6eb; }
  }
  .ql-snow.ql-toolbar button.ql-active { background: #2c2c2c; }

  // Cabecera y pills
  .gpl-dash-header { background: #1f1f1f; border-color: #2c2c2c; box-shadow: none; }
  .gpl-stat-pill { background: #161616; border-color: #2c2c2c; color: #8e9099; }
  .gpl-stat-pill strong { color: #e4e6eb; }

  .gpl-side-search-clear { background: #2c2c2c; color: #b4b7bd; &:hover { background: #EF4444; color: #fff; } }
  .gpl-side-list::-webkit-scrollbar-thumb { background: #2c2c2c; }
  .gpl-item-init--ink { background: #2c2c2c; color: #e4e6eb; }
  .gpl-editor-empty h2 { color: #e4e6eb; }
  .gpl-editor-body { background: #1f1f1f; }
}
</style>
